import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Doctor } from 'entities/doctor'
import { Institution } from 'entities/institution'
import { ReactNode, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Form } from 'utils/hooks'
import { DoctorViewModel } from 'view_models/doctor_view_model'

export const doctorColumnInfoList = (form?: Form<Record<string, unknown>>, institutions?: Institution[]): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'doctor_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '医者コード', th: true, width: 100, form: form, orderAttr: 'doctor_code', searchType: { name: 'code', type: 'text' } },
            {
                name: '所属施設',
                th: true,
                minWidth: 200,
                form: form,
                orderAttr: 'doctor_institution_id',
                searchType: {
                    name: 'institutionName',
                    type: 'text',
                    selectItems: institutions?.map((i) => {
                        return { label: i.name, value: i.id! }
                    }),
                },
            },
            { name: '名前', th: true, minWidth: 200, form: form, orderAttr: 'doctor_name', searchType: { name: 'name', type: 'text' } },
        ],
    }
}

export type DoctorTableDataProps = {
    doctor?: Doctor
    displaySetting: DisplaySetting
}

export const DoctorTableData = ({ doctor, displaySetting }: DoctorTableDataProps): JSX.Element => {
    if (!doctor) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    const vm = new DoctorViewModel(doctor)

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{doctor.id}</TableCell>
                <TableCell>{doctor.code}</TableCell>
                <TableCell>
                    <Link to={`/institutions?id=${doctor.institution?.id}`}>{doctor.institution?.name}</Link>
                </TableCell>
                <TableCell>{vm.fullNameView()}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
